<template>
    <div class="controlSet">
        <div class="page-header">
            <page-header></page-header>
            <div class="option-select">
                <template>

                </template>
                <div class="charts-input">
                    <el-button type='primary' :loading="loading" @click="loadControlConf(false)">{{loading ? '正在加载' : '手动刷新'}}</el-button>
                </div>
            </div>
        </div>
        <div class="css-margin-top">
            <el-card class="box-card" body-style="{min-height:'300px'}">
                <loading v-if="loading"></loading>
                <template v-else>
                    <div class="clearfix chars-header">
                        <span class="card-header-title">参数设置</span>
                        <div class="time-show">
                            {{option.time_stamp}}
                        </div>
                        <div>
                            <el-button v-show="!option.isEdit" type='text' @click="openEdit">编辑</el-button>
                            <el-button v-show="option.isEdit" @click="closeEdit" type="text">取消</el-button>
                            <el-button @click="saveDeviceConf" :loading="loading" v-show="option.isEdit" type="success">
                                {{loading ? '正在加载' : '保存并写入设备'}}
                            </el-button>
                        </div>
                    </div>
                    <!-- TODO 更好的表单验证方式 -->
                    <div v-if="!isMobile" class="table-list">
                        <template>
                            <el-table :data="confData.slice(0,Math.round(confData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input-number v-else v-model="scope.row.data" :disabled="!option.isEdit"
                                                             @change="checkInputNumber"
                                                             :precision="scope.row.precision"
                                                             :step="scope.row.step"
                                                             :min="scope.row.min"
                                                             :max="scope.row.max"></el-input-number>
                                        </div>
                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                        <template>
                            <el-table :data="confData.slice(Math.round(confData.length/2))" class="val-table">
                                <el-table-column prop="name" label="参数名">
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input-number v-else v-model="scope.row.data"
                                                             @change="checkInputNumber"
                                                             :precision="scope.row.precision"
                                                             :step="scope.row.step"
                                                             :min="scope.row.min"
                                                             :max="scope.row.max"></el-input-number>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>

                    <!-- isMobile table -->

                    <div v-if="isMobile" class="table-list">
                        <template>
                            <el-table :data="confData" class="mobile-val-table">
                                <el-table-column prop="name" label="参数名">
                                    <template scope="scope">
                                        <p style="font-size:14px">{{scope.row.name}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="data" label="参数值">
                                    <template scope="scope">
                                        <div class="edit-input">
                                            <p v-if="!option.isEdit">{{scope.row.data}}</p>
                                            <el-input-number v-else size="small" v-model="scope.row.data"
                                                             @change="checkInputNumber"
                                                             :precision="scope.row.precision"
                                                             :step="scope.row.step"
                                                             :min="scope.row.min"
                                                             :max="scope.row.max"></el-input-number>
                                        </div>
                                    </template>

                                </el-table-column>

                            </el-table>
                        </template>

                    </div>
                </template>

            </el-card>

        </div>

    </div>
</template>

<script>
    import {
        mapState
    } from "vuex";
    import Lib from "../../lib/lib.js";
    import pageHeader from "../../components/tempControl/header";
    import loading from "../../components/common/loading";
    import _ from "lodash";

    export default {
        name: "controlSet",
        components: {
            pageHeader,
            loading
        },
        data() {
            return {
                option: {
                    sys_alias: "",
                    isEdit: false,
                    canEdit: false,
                    time_stamp: ""
                },
                test: "",
                loading: "",
                controlLoading: false,
                sys_alias: [],
                val: "",
                confData: [],
                deviceConfName: {},
                paramRange: [],
                peimei: {

//标准参数Uchar类型个数，int,0 ~255，不可空

bzcsUchar:'标准参数Uchar类型个数',

//标准参数Char类型个数，int,0 ~255，不可空

bzcsChar:'标准参数Char类型个数',

//标准参数Uint类型个数，int,0 ~255，不可空

bzcsUint:'标准参数Uint类型个数',

//标准参数Int类型个数，int,0 ~255，不可空

bzcsInt:'标准参数Int类型个数',

//标准参数Ulong类型个数，int,0 ~255，不可空

bzcsUlong:'标准参数Ulong类型个数',

//标准参数Long类型个数，int,0 ~255，不可空

bzcsLong:'标准参数Long类型个数',

//标准参数Float类型个数，int,0 ~255，不可空

bzcsFloat:'标准参数Float类型个数',
                },
                peishui:{
//实时数据Uchar类型个数，int,0 ~255，不可空

                    nReUchar:'实时数据Uchar类型个数',

//实时数据Char类型个数，int,0 ~255，不可空

                    nReChar:'实时数据Char类型个数',

//实时数据Uint类型个数，int,0 ~255，不可空

                    nReUint:'实时数据Uint类型个数',

//实时数据Int类型个数，int,0 ~255，不可空

                    nReInt:'实时数据Int类型个数',

//实时数据Ulong类型个数，int,0 ~255，不可空

                    nReUlong:'实时数据Ulong类型个数',

//实时数据Long类型个数，int,0 ~255，不可空

                    nReLong:'实时数据Long类型个数',

//实时数据Float类型个数，int,0 ~255，不可空

                    nReFloat:'实时数据Float类型个数',

                },

            };
        },
        computed: mapState({
            isMobile: state => state.isMobile,
            deviceInfo: state => state.deviceInfo,
            userInfo: state => state.userInfo
        }),
        created() {
            this.option.sys_alias = "1";
            this.deviceConfName=(this.deviceInfo.category==='配煤'?this.peimei:this.peishui);
        },
        mounted() {
            this.loadData(true);
            Lib.M.selectInputFoc();
        },
        beforeDestroy() {
            this.loading = false;
        },
        methods: {
            loadDeviceConf(is_cache, callback) {

                let params
                params = {
                    sys_alias: this.option.sys_alias,
                    is_cache: is_cache,
                    device_id: this.deviceInfo.device_id
                }
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                var that = this;
                Lib.api.loadDeviceSetting(params, (data) => {
                    if (data.payload && data.payload.data) {
                        try {
                            let jsonData = JSON.parse(data.payload.data)
                            delete jsonData.oother
                            delete jsonData.isSuccess
                            delete jsonData.msg

                            that.paramRange = [];
                            let totle = 0;
                            for (let key in jsonData) {
                                if(that.deviceConfName[key]){
                                    totle += jsonData[key];
                                    that.paramRange.push(totle);
                                }
                            }
                            
                            if (callback){
                                callback(true);
                            }
                            return;
                        } catch (err) {

                        }
                    }
                    if (callback){
                        callback(true);
                    }
                })
            },

            loadControlConf(is_cache, callback) {
                //this.confData = [];
                this.loading = true;
                this.controlLoading = true;
                let params = {
                    conf_type: "standard",
                    sys_alias: this.option.sys_alias,
                    device_id: this.deviceInfo.device_id,
                    is_cache: is_cache,
                           payload: {
                        devNo: 1,
                        type:30
                    }
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                let that = this;
                Lib.api.loadDeviceConf(params, data => {
                    this.loading = false;
                    this.controlLoading = false;
                    // 确认数据是否更新，否则只读
                    if (data.status_code === "SUCCEEDED") {
                        if (data.payload && data.payload.data) {
                            let confData = this.dealDateFn(data, "load");
                            if (confData.length > 0){
                                that.confData = confData;
                                that.option.time_stamp = data.payload.time_stamp;
                                if (callback){
                                    callback();
                                }
                                return;
                            }
                        }
                    }
                    this.$message({
                        message: "网络连接超时：" + data.msg,
                        type: "warning"
                    });
                    if (!this.isMobile) {
                        this.$notify.info({
                            title: "温馨提示",
                            message: "无法连接设备时，无法进行参数修改操作",
                            duration: 3000,
                            offset: 60
                        });
                    }
                    this.closeEdit();
                });
            },
            saveDeviceConf() {
                this.loading = true;
                let payload = this.dealDateFn(this.confData, "post");
                if (payload == false) {
                    this.$message.error("参数错误");
                    return false;
                } else {
                    payload.devNo = 1;
                    payload = JSON.stringify(payload);
                }
                let params = {
                    conf_type: "standard",
                    sys_alias: this.option.sys_alias.toString(),
                    device_id: this.deviceInfo.device_id,
                    payload: payload
                };
                if (this.userInfo.identity === "USER") {
                    params.auth_token = this.userInfo.token;
                } else {
                    params.customer_token = this.userInfo.token;
                }
                Lib.api.setDeviceConf(params, data => {
                    if (data.status_code === "SUCCEEDED") {
                        this.$message.success("修改成功");
                        this.loadControlConf(false);
                        this.closeEdit();
                    } else {
                        this.$message.error(`修改失败：${data.msg}`);
                        this.loading = false;
                    }
                });
            },
            // 处理获取到的配置数据
            dealDateFn(data, type) {
                let confData;
                if (type === "load") {
                    let jsonData = JSON.parse(data.payload.data);
                    confData = [];
                    if (jsonData.oother) {
                        delete jsonData.oother;
                        if (jsonData.msg) {
                            delete jsonData.msg;
                            delete jsonData.isSuccess;
                        }
                    }
                    this.test = jsonData;
                    let jsonDataIndex = 0;
                    for (let key in jsonData) {
                        if (jsonData.hasOwnProperty(key)) {
                            let item = jsonData[key],
                                precision = 0,
                                step = 1, 
                                max = 5000,
                                min = 0;
                            if (this.paramRange.length > 0){
                                if (jsonDataIndex < this.paramRange[0]) {
                                    max = 255;
                                    min = 0;
                                } else if (jsonDataIndex < this.paramRange[1]) {
                                    max = 127;
                                    min = -128;
                                } else if (jsonDataIndex < this.paramRange[2]) {
                                    max = 32767;
                                    min = -32768;
                                } else if (jsonDataIndex < this.paramRange[3]) {
                                    max = 65565;
                                    min = 0;
                                } else if (jsonDataIndex < this.paramRange[4]) {
                                    max = 2147483647;
                                    min = -2147483648;
                                } else if (jsonDataIndex < this.paramRange[5]) {
                                    max = 4294967295;
                                    min = 0;
                                } else if (jsonDataIndex < this.paramRange[6]) {
                                    max = 100000;
                                    min = -100000;
                                    item = parseFloat(item.toFixed(2));
                                    precision = 2;
                                    step = 0.01;
                                }
                            }
                            confData.push({
                                name: key,
                                data: item,
                                precision: precision,
                                step: step,
                                max: max,
                                min: min
                            });
                        }
                        jsonDataIndex++;
                    }
                } else {
                    if (this.paramRange.length < 7){
                        return false;
                    }
                    confData = {};
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (data[i].data === "") {
                            return false;
                        }
                        confData[item.name] = _.round(item.data, 2);
                        if (i < this.paramRange[5]) {
                            confData[item.name] = _.round(item.data);
                        }
                    }
                }
                return confData;
            },
            // 检查输入是否是两位小数
            checkInputNumber(val, index) {
                // this.confData[index].data=_.round(val,2)
                // return _.round(val,2)
            },
            loadData(useCache, callback){
                let that = this;
                this.loadDeviceConf(useCache, function(succ){
                    that.loadControlConf(useCache, callback);
                });
            },
            // 打开编辑
            openEdit() {
                if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                    this.loading = true;
                    var that = this;
                    this.option.isEdit = true;
                    this.loadData(false, function(){
                        that.option.canEdit=true;
                    });
                } else {
                    this.$message.error("权限不足，修改失败");
                }
            },
            closeEdit() {
                this.option.isEdit = false;
            }
        }
    };
</script>

<style scoped>
    .body-style {
        min-height: 300px;
    }

    .set-option {
        display: flex;
        justify-content: space-between;
    }

    .table-list {
        display: flex;
        width: 100%;
    }

    .el-card box-card {
        width: 100%;
    }

    .chars-header {
        font-size: 0.22rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0.3rem;
    }

    .val-table {
        width: 50%;
    }

    .table-list .el-table__header-wrapper thead div {
        background: #71b7ff;
    }

    .scope-input {
        display: flex;
        align-items: center;
    }

    .scope-input > .el-input {
        flex: 1;
    }

    .scope-input > span {
        margin: 0 5px;
    }

    .edit-input {
        margin: 9px 0;
    }
</style>





// WEBPACK FOOTER //
// standConf.vue?25aaaf7d